import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as React from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { LocationService } from "../Services/LocationService";
import ReduxStore from '../../Redux/Store/IndexStore';
import { Dropdown } from 'react-bootstrap';
import { FaBuilding } from 'react-icons/fa6';
import { MdExpandMore } from 'react-icons/md';
const hiddenRoutes = [
  "/RolePermission",
  "/User",
  "/COAMaster",
  "/CustomerMaster",
  "/VendorMaster",
  "/DocumentMaster",
  "/ProductMaster",
  "/ProcessMaster",
  "/PartTemplate",
  "/WorkstationMaster",
  "/NCRCodeMaster",
  "/PriceBreakdown",
  "/Reports",
  "/SearchAll",
  "/overview",
  "/LocationMaster"
];


type Location = {
  code: string;
  name: string;
  locationId: Number,
};


// interface Props {
//   onChange?: (code: string) => void;
// }

interface Props extends RouteComponentProps {
  onChange?: (code: string) => void;
}


interface State {
  locations: Location[];
  selectedCode?: string;
  locationId: Number;
  requestlist?: any;
}

export class LocationDropdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      locations: [],
      selectedCode: undefined,
      locationId: 0,
    };
  }

  componentDidMount() {
    this.getLocation();
  }

  getLocation = () => {
    let requestlist = { ...this.state.requestlist };
    LocationService.GetLocationAll(requestlist)
      .then((result: Location[] | null) => {
        if (result && result.length > 0) {
          const storedId = Number(localStorage.getItem("locationId"));
          const matching = result.find(loc => loc.locationId === storedId);
          const selected = matching || result[0];
          if (!matching) {
            localStorage.setItem("locationId", String(selected.locationId));
              ReduxStore.dispatch({
              type: 'SET_LOCATION',
              payload: selected.locationId,
            });
          }

          
          this.setState({
            locations: result,
            selectedCode: selected.code,
            locationId: selected.locationId
          });

          if (this.props.onChange) {
            this.props.onChange(selected.code);
          }
        }
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
      });
  };

  handleLocationSelect = (location: Location) => {
    this.setState({ 
      selectedCode: location.code, 
      locationId: location.locationId 
    });
    localStorage.setItem("locationId", String(location.locationId));
    ReduxStore.dispatch({
      type: 'SET_LOCATION',
      payload: location.locationId,
    });
    if (this.props.onChange) {
      this.props.onChange(location.code);
    }
  };

  render() {
     const { location } = this.props;
      if (hiddenRoutes.includes(location.pathname)) {
        return null;
      }

    const selectedLocation = this.state.locations.find(loc => loc.locationId === this.state.locationId);
    const displayName = selectedLocation ? selectedLocation.name : "Select Location";

    return (
      <div className="me-2 location-dropdown-wrapper">
        <Dropdown>
          <Dropdown.Toggle 
            variant="light" 
            className="location-dropdown-toggle d-flex align-items-center gap-2"
            id="location-dropdown"
          >
            <FaBuilding className="location-icon" />
            <span className="location-name">{displayName}</span>
            <MdExpandMore className="location-chevron" />
          </Dropdown.Toggle>

          <Dropdown.Menu className="location-dropdown-menu">
            <div className="location-dropdown-header">
              <FaBuilding className="me-2" />
              <span>Switch Location</span>
            </div>
            <div className="dropdown-divider"></div>
            {this.state.locations.map((location) => {
              const isSelected = location.locationId === this.state.locationId;
              return (
                <Dropdown.Item
                  key={String(location.locationId)}
                  className={`location-dropdown-item ${isSelected ? 'active' : ''}`}
                  onClick={() => this.handleLocationSelect(location)}
                >
                  <FaBuilding className="location-item-icon" />
                  <div className="d-flex flex-column align-items-start">
                    <span className="location-item-name">{location.name}</span>
                    {location.code && (
                      <span className="location-item-code">{location.code}</span>
                    )}
                  </div>
                  {isSelected && (
                    <span className="location-current-badge ms-auto">Current</span>
                  )}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

// export default LocationDropdown;
export default withRouter(LocationDropdown);

